import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLtFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_218_3617)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M23.2539 16.1743C23.7363 14.8744 24.0003 13.4683 24.0003 12.0005C24.0003 10.5326 23.7363 9.1265 23.2539 7.82656L12.0003 6.78308L0.746726 7.82656C0.264336 9.1265 0.000335693 10.5326 0.000335693 12.0005C0.000335693 13.4683 0.264336 14.8744 0.746726 16.1743L12.0003 17.2178L23.2539 16.1743Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.2537 7.82568C21.5582 3.25607 17.1597 -0.000427246 12.0001 -0.000427246C6.84055 -0.000427246 2.44204 3.25607 0.746521 7.82568H23.2537Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0003 24.0008C17.1599 24.0008 21.5584 20.7443 23.2539 16.1747H0.746704C2.44222 20.7443 6.84073 24.0008 12.0003 24.0008Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_218_3617",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgLtFlag;
